<template>
  <v-container class="pt-1 white" fluid>
    <v-row>
      <v-col cols="12">
        <video ref="videoPlayer" class="video-js vjs-fluid vjs-default-skin"></video>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import videojs from "video.js";
import firebase from "@/firebaseConfig";
const db = firebase.firestore();
export default {
  name: "VideoPlayer",
  data() {
    return {
      options: {
        autoplay: false,
        controls: true
      }
    };
  },
  methods: {
    startPlay(video, poster) {
      this.player = videojs(
        this.$refs.videoPlayer,
        this.options,
        function onPlayerReady() {
          this.reset();
          this.poster(poster);
          this.src({
            src: video,
            type: "application/x-mpegURL"
          });
          this.load();
        }
      );
    }
  },
  mounted() {
    const id = this.$route.params.id;
    db.collection("videos")
      .doc(id)
      .get()
      .then(doc => {
        this.startPlay(doc.data().link, doc.data().poster);
      });
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
};
</script>
